import React, { useState, useEffect, useCallback, useMemo } from 'react';

import styles from '../HardwareIntegration.module.scss';
import ViewMesh from '../ViewMesh/ViewMesh';
import CreateFirePanel from '../CreateFirePanel/CreateFirePanel';
import EditFirePanel from '../EditFirePanel/EditFirePanel';
import { useParams } from 'react-router-dom';

//redux
import { useSelector, useDispatch } from 'react-redux';
import {
  firePanelStatus,
  // updateFirePanelStatus,
  firePanelList,
  deleteFirePanel,
} from '../../../../../../redux/thunks/firepanel';
import { doReadOrganisationSites } from '../../../../../../redux/thunks/organisation';
import OutlineButton from '../../../../../../components/OutlineButton/OutlineButton';
import Table from '../../../../../../components/Table/Table';
import SquareEdit from '../../../../../../components/SquareEdit/SquareEdit';
import SquareDelete from '../../../../../../components/SquareDelete/SquareDelete';
import Button from '../../../../../../components/Buttons/Button';
import { Search } from '../../../../../../utils/Search';
import useIsMobile from '../../../../../../hooks/useIsMobile';
import MobileTable from '../../../../../../components/MobileTable/MobileTable';
import FlexRow from '../../../../../../components/FlexBox/FlexRow';
import Typography from '../../../../../../components/Typography/Typography';
import SButton from '../../../../../../components/SButton/SButton';
import SDialog from '../../../../../../components/SDialog/SDialog';

const FirePanel = () => {
  const { customerId } = useParams();

  const dispatch = useDispatch();
  const isMobile = useIsMobile()

  const currentPartner = useSelector((state) => state.auth.currentPartner);
  const sites = useSelector((state) => state.organisation.sites);
  const firepanel = useSelector((state) => state.firepanel);

  //state
  const [showCreatePanel, setPanel] = useState(false);
  const [showEditPanel, setEditPanel] = useState(false);
  const [showViewPanel, setViewPanel] = useState(false);
  const [deleteModal, showDeleteModal] = useState(false);
  const [selectedRow, setRow] = useState({});

  const [filters, setFilters] = useState({ name: '', id: '' });
  const [pagination, setPagination] = useState({ total: 0, currentPage: 1, perPage: 7 });

  useEffect(() => {
    setPagination(prev => ({ ...prev, total: firepanel?.firePanelList?.length ? firepanel?.firePanelList?.length : 0 }))
  }, [firepanel?.firePanelList?.length, setPagination]);

  const columns = useMemo(() => {
    const commonColumns = [
      { title: 'Id', field: 'id', name: 'id' },
      { title: 'Fire Panel', field: 'name', name: 'name' },
      {
        title: 'Mesh I/O',
        field: 'site.name',
        render: (columnProps, rowData, row) => (
          <FlexRow width='fit-content'>
            <Typography variant={"b3M"}>{rowData?.meshios?.length}</Typography>
            <SButton
              onClick={() => {
                setRow(rowData);
                setViewPanel(true);
              }}
              style={{ padding: '0.4rem 1.3rem' }}
              variant={"secondary"}
              color={"info"}>
              View
            </SButton>
          </FlexRow>
        ),
      }
    ]

    const actions = [
      {
        title: 'Action',
        field: 'resourceState',
        render: (columnProps, rowData, row) => (
          <FlexRow justifyContent='end' gap='0.5rem'>
            <SquareEdit
              color={'#ff535a'}
              onPress={() => {
                setRow(rowData);
                setEditPanel(true);
              }}
              style={{
                height: '2rem',
                width: '2rem',
              }}
            />
            <SquareDelete
              color={'#ff535a'}
              onPress={() => {
                setRow(rowData);
                showDeleteModal(true);
              }}
              style={{
                height: '2rem',
                width: '2rem',
                padding: '0'
              }}
            />
          </FlexRow>
        ),
        renderM: (columnProps, rowData, row) => (
          <FlexRow justifyContent='end' gap='0.5rem'>
            <SquareEdit
              color={'#ff535a'}
              onPress={() => {
                setRow(rowData);
                setEditPanel(true);
              }}
              style={{
                height: '2rem',
                width: '2rem',
              }}
            />
            <SquareDelete
              color={'#ff535a'}
              onPress={() => {
                setRow(rowData);
                showDeleteModal(true);
              }}
              style={{
                height: '2rem',
                width: '2rem',
                padding: '0'
              }}
            />
          </FlexRow>
        ),
        props: {
          head: {
            style: {
              textAlign: 'center'
            }
          }
        }
      }
    ]

    return {
      allColumns: [...commonColumns, ...actions],
      commonColumns,
      actions
    }

  }, [])

  const mobileFiltersConfig = useMemo(() => {
    return [
      { name: "Fire Panel", key: "name", type: "search" },
      { name: "ID", key: "id", type: "search" },
    ]
  }, [])

  const getStatus = useCallback(() => {
    dispatch(firePanelStatus(currentPartner.partnerId, customerId));
  }, [dispatch, currentPartner.partnerId, customerId]);

  // const updateStatus = useCallback(
  //   (status) => {
  //     dispatch(
  //       updateFirePanelStatus(currentPartner.partnerId, customerId, { enable: status }, (s) => {
  //         if (s === 'success') {
  //           getStatus();
  //         }
  //       }),
  //     );
  //   },
  //   [currentPartner.partnerId, customerId, dispatch, getStatus],
  // );

  const getFirePanel = useCallback(() => {
    dispatch(firePanelList(currentPartner.partnerId, customerId));
  }, [currentPartner.partnerId, customerId, dispatch]);

  const getSite = useCallback(() => {
    if (currentPartner) {
      dispatch(
        doReadOrganisationSites({
          partnerId: currentPartner.partnerId,
          organisationId: customerId,
          displayNotification: false,
        }),
      );
    }
  }, [currentPartner, customerId, dispatch]);

  useEffect(() => {
    // getStatus();
    getFirePanel();
    getSite();
  }, [currentPartner.partnerId, customerId, dispatch, getFirePanel, getSite, getStatus]);

  const deleteFPanel = useCallback(() => {
    dispatch(
      deleteFirePanel(currentPartner.partnerId, customerId, selectedRow.id, (s) => {
        if (s === 'success') {
          showDeleteModal(false);
        }
      }),
    );
  }, [currentPartner.partnerId, customerId, dispatch, selectedRow.id]);

  const hSearchChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }))
  };

  const search = {
    onChange: hSearchChange,
  };

  const filteredData = useCallback(() => {
    let data = firepanel.firePanelList ? firepanel.firePanelList : [];
    if (filters.name !== '') {
      data = Search(data, 'name', filters.name);
    }

    if (filters?.id !== '') {
      data = Search(data, 'id', filters?.id);
    }

    if (!isMobile) {
      data = data.slice(
        (pagination.currentPage - 1) * 7,
        pagination.currentPage * pagination.perPage,
      );
    }
    return data;
  }, [filters?.id, filters.name, firepanel, pagination.currentPage, pagination.perPage, isMobile]);

  const changePage = (p) => {
    const { page, per_page } = p;
    setPagination(prev => ({
      ...prev,
      currentPage: page,
      perPage: per_page,
    }))
  };

  return (
    <>
      <FlexRow justifyContent='space-between' gap='0.2rem' styles={{ marginBottom: '1rem', marginTop: '1rem' }}>
        <Typography variant={"h7M"}>Hardware Integrations</Typography>
        <SButton
          minWidth
          onClick={() => setPanel(true)}
          disabled={sites == null || sites.length === 0}
        >
          Create Fire Panel
        </SButton>
      </FlexRow>

      <div className={styles.table_container}>
        {
          isMobile ?
            <MobileTable
              columns={columns?.commonColumns}
              data={filteredData() || []}
              actions={columns.actions}
              filtersConfig={mobileFiltersConfig}
              filters={filters}
              setFilters={setFilters}
              emptyMessage={'No fire panels found'}
            /> :
            <Table
              columns={columns?.allColumns}
              data={filteredData() || []}
              defaultMessage={'No fire panels found'}
              options={{ search }}
              pagination={pagination}
              changePage={changePage}
            />}
      </div>

      {showViewPanel && (
        <ViewMesh
          togglePopup={(status) => {
            setViewPanel(false);
            if (status) {
              setEditPanel(true);
            }
          }}
          data={selectedRow}
        />
      )}
      {showCreatePanel && (
        <CreateFirePanel
          togglePopup={(s) => {
            if (s === 'success') {
              getFirePanel();
            }
            setPanel(false);
          }}
          useMesh={filteredData() || []}
        />
      )}
      {showEditPanel && (
        <EditFirePanel
          togglePopup={(s) => {
            if (s === 'success') {
              getFirePanel();
            }
            setEditPanel(false);
          }}
          data={selectedRow}
          useMesh={filteredData() || []}
        />
      )}
      {deleteModal && (
        <SDialog
          open={deleteModal}
          onClose={() => {
            showDeleteModal(false);
          }}
          title={'Delete Fire Panel'}
          secondaryButtonConfig={{
            text: 'Cancel',
            onClick: () => {
              showDeleteModal(false);
            }
          }}
          primaryButtonConfig={{
            text: 'Delete',
            color: 'error',
            onClick: () => {
              deleteFPanel();
            }
          }}
        >
          <Typography variant={"b2M"}>Are you sure you want to delete Fire panel "{selectedRow?.name} - {selectedRow?.id}" ? This action is non reversible and will cause you to lose all data associated with the Fire Panel</Typography>
        </SDialog>
      )}
    </>
  );
};

export default FirePanel;
